import { Injectable } from '@angular/core';
import { IWeather } from '../models/interfaces/IWeather';

@Injectable({
  providedIn: 'root',
})

export class WeatherService {
  constructor() {}

  list(): IWeather[] {
    return [
        {
            "place": "ARACAJÚ - SE",
            "uf": "SE",
            "forecast": "https://forecast7.com/en/n10d95n37d07/aracaju/",
            "id": "n10d95n37d07",
            "slug": "aracaju"
        },
        {
            "place": "BELÉM - PA",
            "uf": "PA",
            "forecast": "https://forecast7.com/en/n1d46n48d49/belem/",
            "id": "n1d46n48d49",
            "slug": "belem"
        },
        {
            "place": "BELO HORIZONTE - MG",
            "uf": "MG",
            "forecast": "https://forecast7.com/en/n19d92n43d93/belo-horizonte/",
            "id": "n19d92n43d93",
            "slug": "belo-horizonte"
        },
        {
            "place": "CAMPOS - RJ",
            "uf": "RJ",
            "forecast": "https://forecast7.com/en/n21d76n41d32/campos/",
            "id": "n21d76n41d32",
            "slug": "campos"
        },
        {
            "place": "FORTALEZA - CE",
            "uf": "CE",
            "forecast": "https://forecast7.com/en/n3d73n38d53/fortaleza/",
            "id": "n3d73n38d53",
            "slug": "fortaleza"
        },
        {
            "place": "MACAPÁ - AP",
            "uf": "AP",
            "forecast": "https://forecast7.com/en/0d04n51d07/macapa/",
            "id": "0d04n51d07",
            "slug": "macapa"
        },
        {
            "place": "MACEIÓ - AL",
            "uf": "AL",
            "forecast": "https://forecast7.com/en/n9d65n35d71/maceio/",
            "id": "n9d65n35d71",
            "slug": "maceio"
        },
        {
            "place": "MANAUS - AM",
            "uf": "AM",
            "forecast": "https://forecast7.com/en/n3d12n60d02/manaus/",
            "id": "n3d12n60d02",
            "slug": "manaus"
        },
        {
            "place": "MARABÁ - PA",
            "uf": "PA",
            "forecast": "https://forecast7.com/en/n5d37n49d13/maraba/",
            "id": "n5d37n49d13",
            "slug": "maraba"
        },
        {
            "place": "NATAL - RN",
            "uf": "RN",
            "forecast": "https://forecast7.com/en/n5d78n35d20/natal/",
            "id": "n5d78n35d20",
            "slug": "natal"
        },
        {
            "place": "NAVEGANTES - SC",
            "uf": "SC",
            "forecast": "https://forecast7.com/en/n26d89n48d66/navegantes/",
            "id": "n26d89n48d66",
            "slug": "navegantes"
        },
        {
            "place": "PARANAGUÁ - PR",
            "uf": "PR",
            "forecast": "https://forecast7.com/en/n25d51n48d52/paranagua/",
            "id": "n25d51n48d52",
            "slug": "paranagua"
        },
        {
            "place": "PORTO ALEGRE - RS",
            "uf": "RS",
            "forecast": "https://forecast7.com/en/n30d03n51d22/porto-alegre/",
            "id": "n30d03n51d22",
            "slug": "porto-alegre"
        },
        {
            "place": "RECIFE - PE",
            "uf": "PE",
            "forecast": "https://forecast7.com/en/n8d06n34d88/recife/",
            "id": "n8d06n34d88",
            "slug": "recife"
        },
        {
            "place": "RIO DE JANEIRO - RJ",
            "uf": "RJ",
            "forecast": "https://forecast7.com/en/n22d91n43d17/rio-de-janeiro/",
            "id": "n22d91n43d17",
            "slug": "rio-de-janeiro"
        },
        {
            "place": "RIO GRANDE - RS",
            "uf": "RS",
            "forecast": "https://forecast7.com/en/n32d30n52d45/rio-grande/",
            "id": "n32d30n52d45",
            "slug": "rio-grande"
        },
        {
            "place": "SALVADOR - BA",
            "uf": "BA",
            "forecast": "https://forecast7.com/en/n12d97n38d50/salvador/",
            "id": "n12d97n38d50",
            "slug": "salvador"
        },
        {
            "place": "SANTOS - SP",
            "uf": "SP",
            "forecast": "https://forecast7.com/en/n23d97n46d33/santos/",
            "id": "n23d97n46d33",
            "slug": "santos"
        },
        {
            "place": "SÃO FRANCISCO DO SUL - SC",
            "uf": "SC",
            "forecast": "https://forecast7.com/en/n26d25n48d62/sao-francisco-do-sul/",
            "id": "n26d25n48d62",
            "slug": "sao-francisco-do-sul"
        },
        {
            "place": "SÃO LUIS - MA",
            "uf": "MA",
            "forecast": "https://forecast7.com/en/n2d54n44d28/sao-luis/",
            "id": "n2d54n44d28",
            "slug": "sao-luis"
        },
        {
            "place": "SÃO SEBASTIÃO - SP",
            "uf": "SP",
            "forecast": "https://forecast7.com/en/n23d81n45d40/sao-sebastiao/",
            "id": "n23d81n45d40",
            "slug": "sao-sebastiao"
        },
        {
            "place": "VITÓRIA - ES",
            "uf": "ES",
            "forecast": "https://forecast7.com/en/n20d30n40d30/vitoria/",
            "id": "n20d30n40d30",
            "slug": "vitoria"
        }
    ];
  }
}
